/**
 * Convert test: carrusel-thumbs — VARIANTE B
 * ---------------------------------------------------------------------------
 * Carrusel de la galería de producto con scroll-snap nativo:
 *  - flechas prev/next
 *  - barra de progreso proporcional al scroll
 *  - miniaturas en un solo renglón, sincronizadas con el slide activo
 *  - zoom en desktop (paridad con ImageZoom de la variante A)
 *  - sincronización con el cambio de variante del theme
 *
 * Sólo se inicializa cuando el bloque de la variante B es visible, es decir,
 * cuando Convert inyectó el CSS de activación. Para la variante A este archivo
 * no hace absolutamente nada.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-pdp-gallery-v2]';
  var ZOOM_MIN_RATIO = 1.4;
  var CONVERT_GOAL_THUMB_CLICK = '1004123499';
  var BADGE_INSET = 10;

  /* Goal de Convert: interacción con las miniaturas de la galería. */
  function trackThumbClickGoal() {
    window._conv_q = window._conv_q || [];
    window._conv_q.push(['triggerConversion', CONVERT_GOAL_THUMB_CLICK]);
    console.log('Goal - Click Thumb');
  }

  function isVisible(el) {
    return !!(el && el.getClientRects().length);
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function Gallery(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-gallery-viewport]');
    this.thumbsWrap = root.querySelector('[data-gallery-thumbs-wrap]');
    this.thumbsTrack = root.querySelector('[data-gallery-thumbs]');
    this.progress = root.querySelector('[data-gallery-progress]');
    this.progressBar = root.querySelector('[data-gallery-progress-bar]');
    this.prevBtn = root.querySelector('[data-gallery-prev]');
    this.nextBtn = root.querySelector('[data-gallery-next]');
    this.zoomEl = root.querySelector('[data-gallery-zoom]');

    if (!this.viewport) {
      return;
    }

    this.activeIndex = 0;
    this.scrollTicking = false;
    this.zoomReady = false;

    this.refresh();
    this.bind();
    this.goToInitial();
    this.sync();
    this.placeDiscountBadge();
  }

  /* El badge de "% off" (.o-product-badge__container) vive dentro de
     .o-product-header, que está DESPUÉS de la galería en el DOM, y en mobile se
     posiciona con `top: -58%` de la altura del header para montarse sobre la
     imagen. Ese porcentaje está calibrado para la altura de la galería de la
     variante A; como la variante B es más baja, el badge cae a media imagen,
     justo debajo de la flecha derecha.

     Aquí se calcula el `top` exacto para dejarlo en la esquina inferior derecha
     de la imagen. Sólo en mobile: en desktop el header está en la otra columna y
     el badge nunca dependió de la altura de la galería. */
  Gallery.prototype.placeDiscountBadge = function () {
    var badge = document.querySelector('.o-product-badge__container');
    if (!badge) {
      return;
    }

    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) {
      badge.style.removeProperty('top');
      return;
    }

    var host = badge.offsetParent;
    var stage = this.root.querySelector('.pdp-gallery-v2__stage');
    if (!host || !stage) {
      return;
    }

    var stageBottom = stage.getBoundingClientRect().bottom;
    var hostTop = host.getBoundingClientRect().top;
    var top = stageBottom - hostTop - badge.offsetHeight - BADGE_INSET;

    badge.style.top = Math.round(top) + 'px';
  };

  /* Recalcula la lista de slides/miniaturas visibles. Los elementos ocultos
     (infocards, value props) quedan fuera de la navegación. */
  Gallery.prototype.refresh = function () {
    var self = this;

    this.slides = toArray(this.viewport.querySelectorAll('[data-pdp-slide]')).filter(isVisible);

    this.thumbs = [];
    if (this.thumbsTrack) {
      var thumbsByIndex = {};
      toArray(this.thumbsTrack.querySelectorAll('[data-pdp-thumb]')).forEach(function (thumb) {
        thumbsByIndex[thumb.getAttribute('data-gi')] = thumb;
      });
      this.slides.forEach(function (slide) {
        self.thumbs.push(thumbsByIndex[slide.getAttribute('data-gi')] || null);
      });
    }

    var multiple = this.slides.length > 1;
    if (this.prevBtn) {
      this.prevBtn.hidden = !multiple;
    }
    if (this.nextBtn) {
      this.nextBtn.hidden = !multiple;
    }
    if (this.progress) {
      this.progress.hidden = !multiple;
    }
  };

  Gallery.prototype.bind = function () {
    var self = this;

    this.viewport.addEventListener('scroll', function () {
      if (self.scrollTicking) {
        return;
      }
      self.scrollTicking = true;
      window.requestAnimationFrame(function () {
        self.scrollTicking = false;
        self.sync();
      });
    }, { passive: true });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.goTo(self.activeIndex - 1, true);
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        self.goTo(self.activeIndex + 1, true);
      });
    }

    if (this.thumbsTrack) {
      this.thumbsTrack.addEventListener('click', function (e) {
        var thumb = e.target.closest ? e.target.closest('[data-pdp-thumb]') : null;
        if (!thumb) {
          return;
        }
        e.preventDefault();
        trackThumbClickGoal();
        var index = self.thumbs.indexOf(thumb);
        if (index > -1) {
          self.goTo(index, true);
        }
      });

      this.thumbsTrack.addEventListener('scroll', function () {
        self.updateThumbFades();
      }, { passive: true });
    }

    window.addEventListener('resize', function () {
      self.refresh();
      self.sync();
      self.placeDiscountBadge();
      if (self.zoomEl) {
        self.prepareZoom();
      }
    });

    window.addEventListener('load', function () {
      self.placeDiscountBadge();
    });

    this.bindZoom();
    this.bindVariantSwitch();
  };

  Gallery.prototype.goToInitial = function () {
    var initialId = this.root.getAttribute('data-initial-media-id');
    if (!initialId) {
      return;
    }
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].getAttribute('data-media-id') === initialId) {
        this.goTo(i, false);
        return;
      }
    }
  };

  Gallery.prototype.goTo = function (index, smooth) {
    if (index < 0) {
      index = 0;
    }
    if (index > this.slides.length - 1) {
      index = this.slides.length - 1;
    }

    var slide = this.slides[index];
    if (!slide) {
      return;
    }

    var left = slide.offsetLeft;
    try {
      this.viewport.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    } catch (err) {
      this.viewport.scrollLeft = left;
    }

    this.setActive(index);
  };

  /* Índice del slide cuyo borde izquierdo está más cerca del scroll actual. */
  Gallery.prototype.currentIndex = function () {
    var scrollLeft = this.viewport.scrollLeft;
    var best = 0;
    var bestDistance = Infinity;

    for (var i = 0; i < this.slides.length; i++) {
      var distance = Math.abs(this.slides[i].offsetLeft - scrollLeft);
      if (distance < bestDistance) {
        bestDistance = distance;
        best = i;
      }
    }

    return best;
  };

  Gallery.prototype.sync = function () {
    this.setActive(this.currentIndex());
    this.updateProgress();
  };

  Gallery.prototype.setActive = function (index) {
    this.activeIndex = index;

    for (var i = 0; i < this.thumbs.length; i++) {
      var thumb = this.thumbs[i];
      if (!thumb) {
        continue;
      }
      if (i === index) {
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.classList.remove('is-active');
        thumb.removeAttribute('aria-current');
      }
    }

    if (this.prevBtn) {
      this.prevBtn.disabled = index <= 0;
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = index >= this.slides.length - 1;
    }

    this.revealThumb(index);
    if (this.zoomEl) {
      this.hideZoom();
      this.prepareZoom();
    }
  };

  /* Mantiene la miniatura activa dentro del área visible del renglón, sin
     mover el scroll de la página. */
  Gallery.prototype.revealThumb = function (index) {
    var thumb = this.thumbs[index];
    if (!thumb || !this.thumbsTrack) {
      return;
    }

    var track = this.thumbsTrack;
    var left = thumb.offsetLeft;
    var right = left + thumb.offsetWidth;
    var viewLeft = track.scrollLeft;
    var viewRight = viewLeft + track.clientWidth;
    var target = null;

    if (left < viewLeft + 28) {
      target = left - 28;
    } else if (right > viewRight - 28) {
      target = right - track.clientWidth + 28;
    }

    if (target !== null) {
      target = Math.max(0, target);
      try {
        track.scrollTo({ left: target, behavior: 'smooth' });
      } catch (err) {
        track.scrollLeft = target;
      }
    }

    this.updateThumbFades();
  };

  Gallery.prototype.updateThumbFades = function () {
    if (!this.thumbsWrap || !this.thumbsTrack) {
      return;
    }

    var track = this.thumbsTrack;
    var maxScroll = track.scrollWidth - track.clientWidth;

    this.thumbsWrap.classList.toggle('is-at-start', track.scrollLeft <= 1);
    this.thumbsWrap.classList.toggle('is-at-end', maxScroll <= 1 || track.scrollLeft >= maxScroll - 1);
  };

  Gallery.prototype.updateProgress = function () {
    if (!this.progressBar) {
      return;
    }

    var scrollWidth = this.viewport.scrollWidth;
    if (!scrollWidth) {
      return;
    }

    var ratio = Math.min(1, this.viewport.clientWidth / scrollWidth);
    var offset = this.viewport.scrollLeft / scrollWidth;

    this.progressBar.style.width = (ratio * 100).toFixed(3) + '%';
    this.progressBar.style.transform = 'translateX(' + ((offset / ratio) * 100).toFixed(3) + '%)';
  };

  /* ---------------------------------------------------------------------
     Zoom — sólo en punteros finos (desktop), replicando el comportamiento
     de ImageZoom del theme: click para activar, mousemove para desplazar.
     --------------------------------------------------------------------- */
  Gallery.prototype.bindZoom = function () {
    var self = this;

    if (!this.zoomEl || !window.matchMedia) {
      return;
    }
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      return;
    }

    this.viewport.addEventListener('click', function (e) {
      if (!self.zoomReady) {
        return;
      }
      e.preventDefault();
      self.zoomEl.classList.add('is-active');
      self.moveZoom(e);
    });

    this.zoomEl.addEventListener('click', function () {
      self.hideZoom();
    });

    this.zoomEl.addEventListener('mouseout', function () {
      self.hideZoom();
    });

    this.zoomEl.addEventListener('mousemove', function (e) {
      self.moveZoom(e);
    });

    this.prepareZoom();
  };

  Gallery.prototype.prepareZoom = function () {
    var self = this;

    if (!this.zoomEl) {
      return;
    }

    this.zoomReady = false;
    this.root.classList.remove('is-zoom-enabled');

    var slide = this.slides[this.activeIndex];
    if (!slide || slide.querySelector('video')) {
      return;
    }

    var img = slide.querySelector('img');
    if (!img) {
      return;
    }

    var src = img.currentSrc || img.src;
    if (!src) {
      return;
    }

    var areaWidth = this.viewport.clientWidth;
    var areaHeight = this.viewport.clientHeight;
    if (!areaWidth || !areaHeight) {
      return;
    }

    var probe = new Image();
    probe.onload = function () {
      var ratio = Math.max(probe.width / areaWidth, probe.height / areaHeight);
      if (ratio < ZOOM_MIN_RATIO) {
        return;
      }
      self.zoomWidth = probe.width;
      self.zoomHeight = probe.height;
      self.zoomEl.style.backgroundImage = 'url(' + src + ')';
      self.zoomReady = true;
      self.root.classList.add('is-zoom-enabled');
    };
    probe.src = src;
  };

  Gallery.prototype.moveZoom = function (e) {
    if (!this.zoomEl.classList.contains('is-active')) {
      return;
    }

    var rect = this.zoomEl.getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;

    if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
      return;
    }

    var posX = Math.round((x / rect.width) * this.zoomWidth - rect.width / 2) * -1;
    var posY = Math.round((y / rect.height) * this.zoomHeight - rect.height / 2) * -1;

    posX = Math.min(0, Math.max(posX, -(this.zoomWidth - rect.width)));
    posY = Math.min(0, Math.max(posY, -(this.zoomHeight - rect.height)));

    this.zoomEl.style.backgroundPosition = posX + 'px ' + posY + 'px';
  };

  Gallery.prototype.hideZoom = function () {
    if (this.zoomEl) {
      this.zoomEl.classList.remove('is-active');
    }
  };

  /* Al cambiar de variante, el theme dispara un evento jQuery en window con
     la imagen destacada de la variante. */
  Gallery.prototype.bindVariantSwitch = function () {
    var self = this;

    if (!window.jQuery) {
      return;
    }

    window.jQuery(window).on('shopify-variants:switch-variant.pdpGalleryV2', function (event, data) {
      if (!data || !data.variant || data.firstLoad) {
        return;
      }

      var image = data.variant.featured_image;
      if (!image || !image.id) {
        return;
      }

      var id = String(image.id);
      for (var i = 0; i < self.slides.length; i++) {
        if (self.slides[i].getAttribute('data-media-id') === id) {
          self.goTo(i, true);
          return;
        }
      }
    });
  };

  /* ------------------------------------------------------------------
     Arranque: Convert puede inyectar su CSS después de que este archivo
     se ejecute, así que reintentamos hasta que el bloque sea visible.
     ------------------------------------------------------------------ */
  function init() {
    var root = document.querySelector(ROOT_SELECTOR);

    if (!root || root.__pdpGalleryV2) {
      return !!(root && root.__pdpGalleryV2);
    }
    if (!isVisible(root)) {
      return false;
    }

    root.__pdpGalleryV2 = new Gallery(root);
    return true;
  }

  /* La ventana tiene que ser mayor que la que espera el trigger de la location en
     sections/page-product.liquid (~15s): recién cuando ese trigger corre, Convert
     activa el experimento y este bloque se vuelve visible. Con la ventana anterior
     de 6s el sondeo se rendía antes de tiempo en conexiones lentas. */
  var attempts = 0;
  var MAX_ATTEMPTS = 200; /* ~20s */

  function poll() {
    if (init() || attempts > MAX_ATTEMPTS) {
      return;
    }
    attempts++;
    window.setTimeout(poll, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poll);
  } else {
    poll();
  }
})();
